import { Button } from "@/components/ui/Button";
import { Card, CardBody, CardHeader } from "@/components/ui/Card";

export type ProductionLaborClockOutReason = "idle_timeout" | "forced_server" | "wrap_up";

export function ProductionLaborClockOutModal({
  open,
  reason,
  message,
  contestPending,
  onContest,
  onClockInFresh,
  onDismiss,
}: {
  open: boolean;
  reason: ProductionLaborClockOutReason;
  message: string;
  contestPending: boolean;
  onContest: () => void;
  onClockInFresh: () => void;
  onDismiss: () => void;
}): JSX.Element | null {
  if (!open) return null;

  const title =
    reason === "idle_timeout"
      ? "Clocked out due to inactivity"
      : reason === "wrap_up"
        ? "Batch testing finished"
        : "Labor session ended";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <Card className="w-full max-w-lg shadow-lg">
        <CardHeader>
          <h2 className="text-lg font-semibold">{title}</h2>
        </CardHeader>
        <CardBody className="space-y-4">
          <p className="text-sm text-muted-foreground">{message}</p>
          <div className="flex flex-wrap gap-2">
            {reason === "idle_timeout" ? (
              <Button type="button" disabled={contestPending} onClick={onContest}>
                {contestPending ? "Reopening…" : "Contest idle clock-out"}
              </Button>
            ) : null}
            <Button type="button" variant="secondary" disabled={contestPending} onClick={onClockInFresh}>
              Clock in again
            </Button>
            <Button type="button" variant="secondary" onClick={onDismiss}>
              Stay on this step
            </Button>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}
